
jQuery(document).ready(function ($) {
  $(document).on(
    "click",
    ".post-grid-pagination a.page-numbers:not(.current)",
    function (e) {
      e.preventDefault();

      const link = $(this);
      const paginationContainer = link.closest(".post-grid-pagination");
      const gridContainer = paginationContainer
        .siblings(".huge-post-grid")
        .first();
      const containerId = gridContainer.attr("id");
      const page = link.attr("href").match(/paged?=(\d+)/i) ? RegExp.$1 : 1;

      // Get the widget wrapper
      const widgetWrapper = gridContainer.closest(
        ".elementor-widget-huge-post-grid"
      );

      // Prepare all settings
      const ajaxData = {
        action: "thha_post_grid_pagination",
        poatgrid_nonce: thha_postGrid.nonce,
        page: page,
        container_id: containerId,
        posts_per_page: widgetWrapper.data("posts-per-page"),
        selected_category: widgetWrapper.data("selected-category"),
        post_style: widgetWrapper.data("post-style"),
        settings: {
          show_image: widgetWrapper.data("show-image"),
          show_category: widgetWrapper.data("show-category"),
          show_content: widgetWrapper.data("show-content"),
          content_type: widgetWrapper.data("content-type"),
          show_author: widgetWrapper.data("show-author"),
          show_date: widgetWrapper.data("show-date"),
          image_size: widgetWrapper.data("image-size"),
          title_word_limit: widgetWrapper.data("title-word-limit"),
          content_word_limit: widgetWrapper.data("content-word-limit"),
          columns: widgetWrapper.data("columns"),
        },
      };

      // Add loading state
      gridContainer.addClass("loading");

      $.ajax({
        url: thha_postGrid.ajaxurl,
        type: "POST",
        dataType: "json",
        data: ajaxData,
        success: function (response) {
          console.log( response );
          if (response?.success) {
            gridContainer.parent().html(response.data.html);

            // Update URL without reload
            if (history.pushState) {
              const newUrl = window.location.pathname + "?paged=" + page;
              window.history.pushState({ path: newUrl }, "", newUrl);
            }
          }
        },
        error: function (xhr) {
          console.error("Pagination Error:", xhr.responseText);
          gridContainer.before(
            '<div class="post-grid-error">Failed to load page. Please try again.</div>'
          );
        },
        complete: function () {
          gridContainer.removeClass("loading");
        },
      });
    }
  );
});

jQuery(document).ready(function ($) {  $(document).on("click", ".load-more-btn", function (e) {
    e.preventDefault();

    const button = $(this);
    const container = button.data("container");
    const widgetWrapper = button.closest(".elementor-widget-huge-post-grid");

    // Prepare AJAX data
    const ajaxData = {
      action: "thha_load_more_posts",
      postgrid_nonce: thha_postGrid.nonce,
      page: parseInt(button.data("page")) + 1,
      posts_per_page: button.data("posts-per-page"),
      selected_category: button.data("category"),
      post_style: button.data("post-style"),
      settings: {
        show_image: widgetWrapper.data("show-image"),
        show_category: widgetWrapper.data("show-category"),
        show_content: widgetWrapper.data("show-content"),
        content_type: widgetWrapper.data("content-type"),
        show_author: widgetWrapper.data("show-author"),
        show_date: widgetWrapper.data("show-date"),
        image_size: widgetWrapper.data("image-size"),
        title_word_limit: widgetWrapper.data("title-word-limit"),
        content_word_limit: widgetWrapper.data("content-word-limit"),
        columns: widgetWrapper.data("columns"),
      },
    };

    // Loading state
    button
      .prop("disabled", true)
      .html('<span class="spinner"></span> Loading...');

    $.ajax({
      url: thha_postGrid.ajaxurl,
      type: "POST",
      dataType: "html",
      data: ajaxData,
      success: function (response) {
        if (response && response !== "0") {
          // Append new posts
          $("#" + container).append(response);

          // Update page number
          button.data("page", parseInt(button.data("page")) + 1);

          // Remove button if no more pages
          if (
            parseInt(button.data("page")) >= parseInt(button.data("max-pages"))
          ) {
            button.fadeOut(300, function () {
              $(this).remove();
            });
          } else {
            button.prop("disabled", false).text("Load More");
          }
        } else {
          button.remove();
        }
      },
      error: function (xhr, status, error) {
        console.error("Load More Error:", status, error);
        button.prop("disabled", false).text("Load More");

        // Show error message
        const errorMsg = $(
          '<div class="loadmore-error">Failed to load posts. Please try again.</div>'
        );
        button.after(errorMsg);
        errorMsg.delay(3000).fadeOut();
      },
    });
  });
});
